<template>
  <div class="grid_header">
    <div class="cell justify-center"> {{ colName }}</div>
    <div class="cell">
      <div v-if="this.$slots.default" class="my-n1">
        <slot />
      </div>
      <v-sheet color="transparent" width="100%" class="text-center">
        {{ localStorage.translations.pages.finance['period-table'].quantity }}
      </v-sheet>
    </div>
    <div class="d-flex">
      <div class="cell pl-8"> {{ localStorage.translations.pages.finance['period-table'].work }}</div>
      <div v-if="note" class="cell pl-8"> {{ localStorage.translations.pages.finance['period-table'].note }}</div>
      <div v-if="note" class="cell pl-8"> {{ localStorage.translations.pages.common.text['block'] || 'Block' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatisticProjectReportsBlankConfirmTableHeader",
  props: {
    colName: {
      type: String,
      default: ''
    },
    note: Boolean
  }
}
</script>
